module.exports = __webpack_public_path__ + "img/not_started_icon.ed578905.svg";